import { gql } from '@apollo/client'

export const CREATE_CHART_DATA_POINTS = gql`
  mutation CreateChartDataPoints($data: [ChartDataPointInput!]!) {
    createChartDataPoints(data: $data) {
        count
    }
  }
`
